import anime from 'animejs'
import scrollAnimations from '../scroll-animations'
import './loading-animation.scss'

// const isIOS =
//   typeof navigator !== 'undefined' &&
//   /iPhone|iPad|iPod/i.test(navigator.userAgent)
const isLinkedinApp =
  typeof navigator !== 'undefined' && /LinkedInApp/i.test(navigator.userAgent)

const animateButtons = () => {
  const bigCoverButtons = document.querySelectorAll('.big-cover-button')
  bigCoverButtons.forEach(el => {
    el.style.background = 'none'
  })
  const tl = anime.timeline({ autoplay: false, easing: 'easeOutQuad' })

  tl.add(
    {
      targets: '.big-cover-button__width',
      translateY: ['100%', '0%'],
      duration: 800,
      delay: (el, i) => i * 100,
      begin: () => {
        bigCoverButtons.forEach((el, i) => {
          setTimeout(() => el.classList.add('show'), 400 + 100 * i)
        })
      },
      complete: () => {
        bigCoverButtons.forEach(el => {
          el.style.background = ''
        })
      },
    },
    0
  )

  tl.add(
    {
      targets: '.big-cover-button__sub-title',
      opacity: [0, 1],
      translateY: ['2rem', '0rem'],
      duration: 800,
      delay: (el, i) => i * 100,
    },
    200
  )

  tl.add(
    {
      targets: '.big-cover-button__title-inner',
      opacity: [0, 1],
      translateY: ['2rem', '0rem'],
      duration: 800,
      delay: (el, i) => i * 100,
    },
    200
  )

  tl.add(
    {
      targets: '.big-cover-button__arrow',
      opacity: [0, 1],
      duration: 400,
      delay: (el, i) => i * 100,
    },
    200
  )

  tl.add(
    {
      targets: '.big-cover-button__arrow svg',
      translateY: ['0.5rem', '0rem'],
      opacity: [0, 1],
      duration: 400,
      delay: (el, i) => i * 100,
    },
    200
  )

  return tl
}

export default () => {
  const tl = anime.timeline({
    autoplay: false,
    easing: 'easeOutQuad',
  })

  tl.add({
    targets: '.preloader',
    opacity: [1, 0],
    duration: 800,
  })

  tl.add(
    {
      targets: '.header-bottom__vertical-line',
      scaleY: [0, 1],
      duration: 800,
    },
    400
  )
  tl.add(
    {
      targets: '.header-horizontal-line',
      scaleX: [0, 1],
      duration: 800,
    },
    400
  )
  tl.add(
    {
      targets: '.scroll-progress-indicator',
      scaleY: [0, 1],
      duration: 800,
    },
    800
  )

  tl.add({
    targets: '.header-logo svg',
    translateY: ['100%', '0%'],
    duration: 800,
  })

  tl.add({
    targets: '.hamburger__line',
    scaleX: [0, 1],
    duration: 800,
    delay: (el, i) => i * 100,
    complete: ({ animatables }) => {
      animatables.forEach(({ target }) => {
        target.style.transform = ''
      })
      const hamburger = document.querySelector('.hamburger')
      if (hamburger) {
        hamburger.classList.add('js-animation-done')
      }
    },
  })

  tl.add(
    {
      targets: '.header-bottom li a',
      translateY: ['100%', '0%'],
      duration: 400,
      delay: (el, i) => i * 50,
    },
    '-=800'
  )

  const animateHeaderAndCover = () => {
    tl.play()
    setTimeout(() => {
      scrollAnimations(document.body)
    }, 2000)
  }

  const shortPreloader = localStorage.getItem('shortPreloader') !== null
  const preloaderVideo = document.querySelector('[data-preloader-video]')
  if (preloaderVideo && !shortPreloader && !isLinkedinApp) {
    preloaderVideo.style.visibility = 'visible'
    preloaderVideo.play()
    preloaderVideo.onended = animateHeaderAndCover
    localStorage.setItem('shortPreloader', '')
  } else {
    animateHeaderAndCover()
  }

  return new Promise(resolve => {
    const buttons = animateButtons()
    tl.finished.then(() => {
      buttons.play()
      buttons.finished
        .then(result => {
          document
            .querySelectorAll('[data-remove-class-on-finish]')
            .forEach(el => {
              if (el && el.dataset) {
                el.classList.remove(el.dataset.removeClassOnFinish)
              }
            })
          return result
        })
        .then(resolve)
    })
  })
}
